import CustomComponent from '../CustomComponent';
import { HIDE_MODAL_EVENT } from './BasicModal';

export class TooManyFavouriteModal extends CustomComponent {
	static key = 'lta-too-many-fav-modal';

	static get observedAttributes() {
		return ['show', 'title', 'subtitle', 'description', 'button-label'];
	}

    constructor() {
        super();
        this.state = {};
    }

    async handleModalClose(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dispatchEvent(
            new CustomEvent(HIDE_MODAL_EVENT, {
                bubbles: true,
                composed: true,
            })
        );
    }

	render() {
        const { show, title, subtitle, description, buttonLabel = 'Close' } = this.props;

        const modalContent = `
            <div class="u-text-center">
                ${subtitle 
                    ?   `<p class="u-text-center u-text-lta-dark-blue">
                            ${subtitle}
                        </p>` 
                    :   ''
                }
                ${title 
                    ?   `<h2 class="js-favorite-icon-action-modal-dynamic-heading u-title-case1 u-text-lta-dark-blue">
                            ${title}
                        </h2>` 
                    :   ''
                }
            </div>
            <div class="lta-modal-body u-text-center">
                ${description 
                    ?   `<p class="js-favorite-icon-action-modal-dynamic-description u-text-center u-label1 u-text-lta-dark-blue">
                            ${description}
                        </p>` 
                    : ''
                }
                <div class="u-flex u-mt-4">
                    <div class="js-my-modal-exit--actions-item u-w-100 u-mb-1">
                        <lta-button classes="js-close-modal-btn" label="${buttonLabel}"></lta-button>
                    </div>
                </div>
            </div>
        `;

		// Render the BasicModal with this content as children
		return `
			<lta-modal show=${show}>
                ${modalContent}
			</lta-modal>
		`;
	}

    afterRender() {
        this.querySelector('.js-close-modal-btn')?.addEventListener('click', this.handleModalClose.bind(this));
    }

    onUnload() {
        this.querySelector('.js-close-modal-btn')?.removeEventListener('click', this.handleModalClose.bind(this));
    }
}
